/**
 * Dedup Module Routes
 *
 * Route definitions for the Dedup module.
 * - /dedup → De-duplication wizard
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/dedup',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.data_cleanup',
        },
        children: [
            {
                path: '',
                name: 'dedup-wizard',
                component: () => import('./views/DedupWizard.vue'),
                meta: {
                    title: 'Data Cleanup',
                },
            },
        ],
    },
]

export default routes
